import { formatWithOptions } from 'date-fns/fp';
import { curryN } from 'lodash/fp';
import { MONTH_FULL_NAME_FORMAT } from '../../constants';
import ensureParseISO from './ensureParseISO';
/**
 * Format date to localized month name
 *
 * @param {object} locale - date-fns locale object
 * @param {(Date | string | number)} dateString - the original date
 *
 * @returns {string} the formatted date string
 *
 * @example
 * getMonthName(enUS)(new Date('1980-10-28') // returns 'October'
 */

var getMonthName = curryN(2, function (locale, dateString) {
  var date = ensureParseISO(dateString);
  return formatWithOptions({
    locale: locale
  }, MONTH_FULL_NAME_FORMAT)(date);
});
export default getMonthName;